<template>
  <v-dialog v-model="value" content-class="base__modal pa-10" max-width="70%">
    <div class="d-flex justify-space-between align-baseline mb-8">
      <h3 class="primary--text">{{ title }}</h3>
      <v-btn text @click="$emit('close')">
        <v-icon class="fa dialog__close-btn">fa-times</v-icon>
      </v-btn>
    </div>
    <v-form ref="form" @submit.prevent="submit">
      <v-row>
        <v-col cols="12" class="pb-5">
          <DropFile
            v-bind="[$attrs]"
            @selected-files="addFiles"
            :multiple="true"
          />
          <BaseErrorMessages
            v-if="errorMessages.length > 0"
            :error-messages="errorMessages"
          />
          <DocumentDataTable
            class="mt-5"
            v-if="newDocuments && newDocuments.length > 0"
            :documents="newDocuments"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFile"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="3">
          <BaseButton
            type="submit"
            class="secondary"
            width="100%"
            v-html="'ANEXAR'"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>

<script>
import { FILE } from "@/mixins/DocumentsMixin";
import DropFile from "@/components/DropFile.vue";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
export default {
  name: "SingleDocumentModal",
  components: { DropFile, DocumentDataTable },
  props: {
    value: { type: Boolean, twoWay: true },
    title: { type: String },
    typeDocument: { type: String },
    currentDocuments: { type: Array }
  },
  data() {
    return {
      newDocuments: [],
      errorMessages: []
    };
  },
  mixins: [DocumentsMixin],
  methods: {
    addFiles(files) {
      this.newDocuments = this.newDocuments.concat(
        files.map(file => ({
          tipo_documento: {
            id: this.typeDocument
          },
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFile(item) {
      this.newDocuments = this.newDocuments.filter(
        document => document.arquivo.nome !== item.arquivo.nome
      );
    },
    validate() {
      this.errorMessages =
        this.newDocuments.length > 0
          ? []
          : ["É preciso adicionar pelo menos um documento"];
      return this.newDocuments.length > 0;
    },
    submit() {
      if (this.validate()) this.$emit("submit", this.newDocuments);
      this.newDocuments = [];
    }
  }
};
</script>
